import { apiRequest } from "../api/http";

// Ads endpoints are admin only ("ads" section). All of them reject on failure.
const adminOptions = { rethrow: true };

export function getAdsList() {
  return apiRequest("get", "/api/ads/list-ads", adminOptions);
}

export function getAdDetails(ad_id) {
  return apiRequest("get", `/api/ads/ads-details/${ad_id}`, adminOptions);
}

export function createAd(ad) {
  return apiRequest("post", "/api/ads/create-ads", {
    ...adminOptions,
    data: ad,
  });
}

export function updateAd(ad_id, ad) {
  return apiRequest("put", `/api/ads/update-ads/${ad_id}`, {
    ...adminOptions,
    data: ad,
  });
}

export function deleteAd(ad_id) {
  return apiRequest("delete", `/api/ads/delete-ads/${ad_id}`, adminOptions);
}

/** Links an uploaded JW Player media to the ad. */
export function setAdMediaId(ad_id, media_id) {
  return apiRequest("put", `/api/ads/set-mediaId/${ad_id}`, {
    data: { media_id },
    rethrow: true,
  });
}
